import { render, staticRenderFns } from "./releaseProject.vue?vue&type=template&id=2ed8440a&scoped=true&"
import script from "./releaseProject.vue?vue&type=script&lang=js&"
export * from "./releaseProject.vue?vue&type=script&lang=js&"
import style0 from "./releaseProject.vue?vue&type=style&index=0&id=2ed8440a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed8440a",
  null
  
)

export default component.exports